<template>
  <div>
    <b-container fluid class="products-filter p-0 pb-1 d-none d-sm-block">
      <FilterProductSelector
        v-on:changeOrder="updateOrder($event)"
        v-on:changePage="updatePage($event)"
        v-on:changeViewType="updateViewType($event)"
        :allowOrdering="allowOrdering"
        :perPage="perPage"
        :viewType="viewType"
        :filterOrderBy="filterOrderBy"
      ></FilterProductSelector>
    </b-container>
    <vue-element-loading :active="loading_products" />
    <div
      v-if="products.length == 0 && this.$route.params.listType != 'offers'"
      class="d-flex justify-content-around mt-3"
    >{{ $t('products_viewer.no_results') }}</div>
    <div
      v-else-if="products.length == 0 && this.$route.params.listType == 'offers'"
      class="d-flex justify-content-around mt-3"
    >{{ $t('products_viewer.no_results_offers') }}</div>
    <div v-else>
      <ProductsViewerPagination
        :start="start"
        :end="end"
        :total="totalItems"
        :perPage="Number(perPage)"
        v-model="currentPage"
        class="p-0 mt-3"
      />
      <!--- lo de ocultar los productos es por el issue #322 --->
      <div v-if="viewType == 'grid' && !loading_products" class="grid-view mt-3">
        <ProductCard
          v-for="(product, index) in products"
          :key="index"
          :product="product"
          class="mb-5"
        />
      </div>
      <!--- lo de ocultar los productos es por el issue #322 --->
      <div v-if="viewType != 'grid' && !loading_products" class="mt-3">
        <WideProductCard
          v-for="(product, index) in products"
          :key="index"
          :product="product"
          class="wide-card mb-4 pb-4"
        />
      </div>
      <ProductsViewerPagination
        :start="start"
        :end="end"
        :total="totalItems"
        :perPage="Number(perPage)"
        v-model="currentPage"
        class="p-0 mt-3"
      />
    </div>
  </div>
</template>


<script>
import { mapState } from "vuex";
import ProductCard from "@/components/ProductCard";
import WideProductCard from "@/components/WideProductCard";
import FilterProductSelector from "@/components/FilterProductSelector";
import ProductsViewerPagination from "@/components/ProductsViewerPagination";

export default {
  components: {
    ProductCard,
    WideProductCard,
    FilterProductSelector,
    ProductsViewerPagination,
  },
  props: {
    source: String,
    payload: {
      type: Object,
      default: () => {},
    },
    categoryUuid: String,
    groupedCategoryUuid: String,
    brandUuid: String,
    pharmacyUuid: String,
    filterAllowOrdering: {
      type: Boolean,
      default: true,
    },
    filterOrderBy: {
      type: String,
      default: "highestPrice",
    },
    // ordenación por defecto cuando el valor de filterOrderBy es "none"
    noneOrderBy: {
      type: String,
      default: undefined,
    },
    filterPerPage: {
      type: String,
      default: "24",
    },
    filterViewType: {
      type: String,
      default: "grid",
    },
  },
  data() {
    return {
      allowOrdering: this.filterAllowOrdering,
      orderBy: this.filterOrderBy,
      perPage: this.filterPerPage,
      viewType: this.filterViewType,
      currentPage: 1,
      loading_products: false,
    };
  },
  computed: {
    ...mapState({
      products: state => state.drugs.viewer.products,
      totalItems: state => state.drugs.viewer.total,
    }),
    start: function() {
      return this.perPage * (this.currentPage - 1) + 1;
    },
    end: function() {
      return Math.min(this.perPage * this.currentPage, this.totalItems);
    },
  },
  watch: {
    source: function() {
      this.loadProductsFirstPage();
    },
    payload: function() {
      this.loadProductsFirstPage();
    },
    categoryUuid: function() {
      this.loadProductsFirstPage();
    },
    groupedCategoryUuid: function() {
      this.loadProductsFirstPage();
    },
    brandUuid: function() {
      this.loadProductsFirstPage();
    },
    pharmacyUuid: function() {
      this.loadProductsFirstPage();
    },
    phUuid: function() {
      this.loadProductsFirstPage();
    },
    orderBy: function() {
      this.loadProducts();
    },
    perPage: function() {
      this.loadProductsFirstPage();
    },
    currentPage: function() {
      this.loadProducts();
    },
    filterAllowOrdering: function() {
      this.allowOrdering = this.filterAllowOrdering;
    },
    filterOrderBy: function() {
      this.orderBy = this.filterOrderBy;
    },
    filterPerPage: function() {
      this.perPage = this.filterPerPage;
    },
    filterViewType: function() {
      this.viewType = this.filterViewType;
    },
  },
  serverPrefetch() {
    return this.loadProducts();
  },
  created() {
    this.loadProducts();
  },
  methods: {
    updateOrder(value) {
      this.orderBy = value;
    },
    updatePage(value) {
      this.perPage = value;
    },
    updateViewType(value) {
      this.viewType = value;
    },
    loadProductsFirstPage() {
      this.currentPage = 1;
      this.loadProducts();
    },
    loadProducts: function() {
      // #323
      if (process.browser) {
        window.scrollTo(0, 0);
      }
      var payload = Object.assign({}, this.payload);
      payload.per_page = this.perPage;
      payload.current_page = this.currentPage;
      if (this.allowOrdering) {
        if (this.orderBy == "highestPrice") {
          payload.ordering = "-best_price_to_public";
        } else if (this.orderBy == "lowerPrice") {
          payload.ordering = "best_price_to_public";
        } else if (this.noneOrderBy) {
          payload.ordering = this.noneOrderBy;
        }
      }
      if (this.categoryUuid) {
        payload.dcUuid = this.categoryUuid;
      }
      if (this.groupedCategoryUuid) {
        payload.groupedCategoryUuid = this.groupedCategoryUuid;
      }
      if (this.brandUuid) {
        payload.dbUuid = this.brandUuid;
      }
      if (this.pharmacyUuid) {
        payload.doUuid = this.pharmacyUuid;
      }
      if (this.phUuid) {
        payload.phUuid = this.phUuid;
      }
      this.loading_products = true;
      return this.$store.dispatch(this.source, payload).then(
        response => {
          this.$store.commit("drugs/MUTATE_VIEWER", {
            products: response.data.results,
            total: response.data.count,
          });
          this.loading_products = false;
        },
        err => {
          this.$store.commit("drugs/MUTATE_VIEWER", {
            products: [],
            total: 0,
          });
          this.loading_products = false;
          this.$sentry({ capture: err });
          this.mnotify_error({
            text: this.$t("products_viewer.error.load_products"),
          });
        }
      );
    },
  },
  fallbackI18n: {
    messages: {
      und: {
        products_viewer: {
          no_results: "No results found",
          no_results_offers: "At the moment there are no offers available",
          prev: "Prev",
          next: "Next",
          error: {
            load_products: "Cannot load products",
          },
        },
      },
    },
  },
};
</script>


<style lang="scss" scoped>
.products-filter {
  border-bottom: 1px solid $grey4-color;
}

.grid-view {
  display: grid;
  grid-template-columns: repeat(auto-fit, $product-card-max-width);
  justify-content: flex-start;
  column-gap: $product-margin-column;
}

@include media-breakpoint-down(sm) {
  .grid-view {
    grid-template-columns: repeat(auto-fit, $product-card-max-width * 0.6);
    column-gap: $product-margin-column * 0.4;
  }
}

.velmld-spinner {
  top: 10rem !important;
}

.wide-card {
  border-bottom: 1px solid $grey4-color;
}
</style>
